module.exports = __webpack_public_path__ + "img/中国银行.6780caf8.png";